;
(function ($) {
  var dataKey = 'app.paysteps';
  var PaySteps = function PaySteps(element, options) {
    this.element = element;
    this.init(options);
  };
  PaySteps.prototype = {
    settings: {
      scrollOffset: -100,
      speed: 500
    },
    attr: {
      payStep: 'data-payment-step',
      payStepHeader: 'data-payment-header',
      next: 'data-payment-confirm',
      previous: 'data-payment-previous'
    },
    classes: {
      active: 'payment-step--active',
      confirmed: 'payment-step--confirmed',
      visited: 'payment-step--visited',
      blocked: 'payment-step--blocked'
    },
    /**
     * Initialise Payment Steps
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      $(this).app_paystepsnavigator($(this.element));
      this._eventSubscriber();
      this._previousStepEventListener();
      this._stepEventListener();
    },
    /**
     * Step Header Event Subscriber
     * Subscribes to a successful step continuation.
     * @private
     */

    _eventSubscriber: function _eventSubscriber() {
      var _this = this;
      $(document).bind('paystep:change', function (e, data) {
        var $step = $(_this.element).find('[' + _this.attr.payStep + '="' + data.key + '"]');
        var $nextStep = _this._getNextStep($step);
        _this._onStepContinue($step, $nextStep);
        _this._scrollToStep($nextStep);
        $(this).app_paystepsnavigator($(_this.element));
      });
    },
    /**
     * Step Header Event Listener
     * Listens for a mouse click on the header.
     * Listens for a key press (spacebar) on the header. This is for accessibility purposes.
     * @private
     */

    _stepEventListener: function _stepEventListener() {
      var _this = this;
      $(this.element).find('[' + this.attr.payStepHeader + ']').each(function () {
        $(this).on('click', function () {
          if (!$(this).parents('[' + _this.attr.payStep + ']').hasClass(_this.classes.blocked)) {
            var $step = $(this).parents('[' + _this.attr.payStep + ']');
            _this._onStepClick($step);
            _this._scrollToStep($step);
            $(this).app_paystepsnavigator($(_this.element));
          }
        });
        $(this).bind('keypress', function (e) {
          if (e.keyCode === 32) {
            if (!$(this).parents('[' + _this.attr.payStep + ']').hasClass(_this.classes.blocked)) {
              var $step = $(this).parents('[' + _this.attr.payStep + ']');
              _this._onStepClick($step);
              _this._scrollToStep($step);
              $(this).app_paystepsnavigator($(_this.element));
              return false;
            }
          }
        });
      });
    },
    /**
     * Previous Step Event Listener
     * Listens for a mouse click on the previous button.
     * Listens for a key press (spacebar) on the previous button. This is for accessibility purposes.
     * @private
     */

    _previousStepEventListener: function _previousStepEventListener() {
      var _this = this;
      $(this.element).find('[' + this.attr.previous + ']').each(function () {
        $(this).on('click', function () {
          var $step = $(this).parents('[' + _this.attr.payStep + ']');
          _this._onClickPrevious($step);
          _this._scrollToStep(_this._getPreviousStep($step));
          $(this).app_paystepsnavigator($(_this.element));
        });
        $(this).bind('keypress', function (e) {
          var $step = $(this).parents('[' + _this.attr.payStep + ']');
          if (e.keyCode === 32) {
            _this._onClickPrevious($step);
            _this._scrollToStep(_this._getPreviousStep($step));
            $(this).app_paystepsnavigator($(_this.element));
            return false;
          }
        });
      });
    },
    /**
     * Scroll To Top
     * Scrolls the users browser to the top of the active payment step.
     * @param {selector} $step
     * @private
     */

    _scrollToStep: function _scrollToStep($step) {
      var _this = this;
      $('html, body').stop();
      $('html, body').on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
        $('html, body').stop();
      });
      $('html, body').animate({
        scrollTop: $step.offset().top + _this.settings.scrollOffset
      }, _this.settings.speed, function () {
        $('html, body').off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });
    },
    /**
     * Make Step Active
     * Updates the requested step to be active.
     * @param {selector} $step
     * @private
     */

    _makeStepActive: function _makeStepActive($step) {
      $step.removeClass(this.classes.visited);
      $step.addClass(this.classes.active);
    },
    /**
     * Make Step Completed
     * Updates the requested step to be completed.
     * @param {selector} $step
     * @private
     */

    _makeStepCompleted: function _makeStepCompleted($step) {
      $step.addClass(this.classes.confirmed);
      $step.removeClass(this.classes.active);
    },
    /**
     * Make Step Visited
     * Updates the requested step to be visited but not completed.
     * @param {selector} $step
     * @private
     */

    _makeStepVisited: function _makeStepVisited($step) {
      $step.addClass(this.classes.visited);
      $step.removeClass(this.classes.active);
    },
    /**
     * Get Next Step
     * Returns the next step after the active step.
     * @param {selector} $step
     * @private
     */

    _getNextStep: function _getNextStep($step) {
      return $step.next();
    },
    /**
     * Get Previous Step
     * Returns the previous step before the active step.
     * @param {selector} $step
     * @private
     */

    _getPreviousStep: function _getPreviousStep($step) {
      return $step.prev();
    },
    /**
     * Get Current Step
     * Returns the active step.
     * @private
     */

    _getCurrentStep: function _getCurrentStep() {
      return $(this.element).find('.' + this.classes.active);
    },
    /**
     * On Step Click
     * On Click of the step header.
     * @param {selector} $step
     * @private
     */

    _onStepClick: function _onStepClick($step) {
      var $current = this._getCurrentStep();
      this._makeStepActive($step);
      if (!$current.hasClass(this.classes.confirmed) && !$step.is($current)) {
        this._makeStepVisited($current);
      } else if (!$step.is($current)) {
        $current.removeClass(this.classes.active);
      }
    },
    /**
     * On Click Continue
     * On successful continue of a step.
     * @param {selector} $step
     * @private
     */

    _onStepContinue: function _onStepContinue($step, $nextStep) {
      this._makeStepActive($nextStep);
      this._makeStepCompleted($step);
    },
    /**
     * On Click Previous
     * On Click of the step previous button.
     * @param {selector} $step
     * @private
     */

    _onClickPrevious: function _onClickPrevious($step) {
      var $prevStep = this._getPreviousStep($step);
      var confirmButton = $prevStep.find('.btn--danger');
      this._makeStepActive($prevStep);
      if (!$step.hasClass(this.classes.confirmed)) {
        this._makeStepVisited($step);
      } else {
        $step.removeClass(this.classes.active);
      }
      if (confirmButton) {
        confirmButton.removeClass('btn--danger');
        confirmButton.html('Continue');
      }
    }
  };

  /**
   * Global callback function which by default all [data-payment-steps] triggers this plugin.
   * @method $.fn.app_paysteps()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_paysteps();
   */

  $.fn.app_paysteps = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof PaySteps) {
      plugin.init();
    } else {
      plugin = new PaySteps(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);